import util from '../util';
import GoalWidget from './GoalWidget';

export default class GiftGoalWidget extends GoalWidget {
	applySettings(settings) {
		Object.getPrototypeOf(GoalWidget.prototype).applySettings.call(this, settings);
		if(this.userData?.currency_code)
			this.settings.currency_code = this.userData.currency_code;
		this.goal = parseFloat(this.settings.goal || 0) || 0;
		this.amount = parseFloat(this.settings.amount || 0) || 0;
		this._render();
	}

	setAmount(amount) {
		this.amount = amount;
		this._render();
	}

	addAmount(amount) {
		this.setAmount((this.amount || 0) + amount);
	}

	_render() {
		if(!this.settings) return;
		const progressAmountEl = this.container.querySelector('.progressAmount');
		if(!progressAmountEl) return;
		const pct = Math.round((this.goal ? (this.amount || 0) / this.goal : 0) * 100);
		progressAmountEl.style.width = `${pct}%`;
		const currency = this.settings.currency_code || 'USD';
		const decimals = this.settings.decimals != null ? Math.max(0, Math.min(4, this.settings.decimals)) : 0;
		const decimalOpts = { minimumFractionDigits: decimals, maximumFractionDigits: decimals };
		let progressText = this.settings.hideCurrency ? (this.amount || 0).toFixed(decimals) : util.generateValueString(this.amount || 0, currency, decimalOpts);
		let goalString = this.settings.hideCurrency ? (this.goal || 0).toFixed(decimals) : util.generateValueString(this.goal || 0, currency, decimalOpts);
		let goalText = '';
		if(!this.settings.hidePercentage) {
			if(this.settings.centerGoal)
				goalText += `${pct}%`;
			else
				progressText += ` (${pct}%)`;
		}
		if(this.settings.centerGoal) progressText += ` / ${goalString}`;
		else goalText += goalString;
		if(this.settings.appendToGoal)
			goalText += this.settings.appendToGoal;
		this.container.querySelector('.progressText').innerText = progressText;
		this.container.querySelector('.goal').innerText = goalText;
		this.container.querySelector('.title').innerText = this.settings.title || '';
	}
}
